module.exports = __webpack_public_path__ + "static/media/selectRed.a4c3378c.svg";